"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.Modal = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 998;\n    background: rgba(38, 43, 51, 0.4);\n"], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 998;\n    background: rgba(38, 43, 51, 0.4);\n"])));
exports.WrapperPopup = styled_components_1.default(function (_a) {
  var width = _a.width,
      height = _a.height,
      rest = __rest(_a, ["width", "height"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    height: ", "px;\n    width: ", "px;\n    justify-content: center;\n    left: 18%;\n    top: 10%;\n    position: absolute;\n    z-index: 999;\n"], ["\n    display: flex;\n    flex-direction: column;\n    height: ", "px;\n    width: ", "px;\n    justify-content: center;\n    left: 18%;\n    top: 10%;\n    position: absolute;\n    z-index: 999;\n"])), function (props) {
  return props.height * 0.8;
}, function (props) {
  return props.width * 0.7;
});
exports.ModalBoxNumbers = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    top: ", "%;\n    left: 23%;\n    width: 40%;\n"], ["\n    position: absolute;\n    top: ", "%;\n    left: 23%;\n    width: 40%;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isMedium(activeBreakpoint) ? 22 : 17;
});
exports.OutsideWrapper = styled_components_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: 100%;\n    width: 100%;\n"], ["\n    height: 100%;\n    width: 100%;\n"])));
exports.ModalEnhancer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 50%;\n    height: ", "%;\n    margin-left: 17%;\n    margin-top: 2%;\n    position: absolute;\n"], ["\n    width: 50%;\n    height: ", "%;\n    margin-left: 17%;\n    margin-top: 2%;\n    position: absolute;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isMedium(activeBreakpoint) ? 50 : 75;
});
exports.IconBox = styled_components_1.default(function (_a) {
  var rest = __rest(_a, []);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: relative;\n    top: 20px;\n    right: 25px;\n"], ["\n    position: relative;\n    top: 20px;\n    right: 25px;\n"])));
exports.ImageModal = styled_components_1.default(function (_a) {
  var rest = __rest(_a, []);

  return react_1.default.createElement(react_native_1.Image, __assign({}, rest));
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n"], ["\n    width: 100%;\n    height: 100%;\n"])));
exports.ImagePointer = styled_components_1.default(function (_a) {
  var rest = __rest(_a, []);

  return react_1.default.createElement(react_native_1.Image, __assign({}, rest));
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 17px;\n    height: 14px;\n"], ["\n    width: 17px;\n    height: 14px;\n"])));
exports.MobileBoxTitle = styled_components_1.default(function (_a) {
  var rest = __rest(_a, []);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    flex: 1;\n    padding-top: 100px;\n    position: relative;\n    left: 10px;\n"], ["\n    flex: 1;\n    padding-top: 100px;\n    position: relative;\n    left: 10px;\n"])));
exports.MobileBoxText = styled_components_1.default(function (_a) {
  var rest = __rest(_a, []);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    flex: 5;\n    padding-left: 12px;\n    padding-right: 12px;\n"], ["\n    flex: 5;\n    padding-left: 12px;\n    padding-right: 12px;\n"])));
exports.LefBox = styled_components_1.default(react_native_1.TouchableOpacity)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    height: 100%;\n    width: 15%;\n    position: absolute;\n    cursor: default;\n    z-index: 2;\n"], ["\n    height: 100%;\n    width: 15%;\n    position: absolute;\n    cursor: default;\n    z-index: 2;\n"])));
exports.RightBox = styled_components_1.default(react_native_1.TouchableOpacity)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    height: 100%;\n    width: 23%;\n    right: 0px;\n    position: absolute;\n    cursor: default;\n    z-index: 2;\n"], ["\n    height: 100%;\n    width: 23%;\n    right: 0px;\n    position: absolute;\n    cursor: default;\n    z-index: 2;\n"])));
exports.BottomBox = styled_components_1.default(react_native_1.TouchableOpacity)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    height: 10%;\n    width: 100%\n    bottom: 0px;\n    position: absolute;\n    cursor: default;\n    z-index: 2;\n"], ["\n    height: 10%;\n    width: 100%\n    bottom: 0px;\n    position: absolute;\n    cursor: default;\n    z-index: 2;\n"])));
exports.ContentWrapper = styled_components_1.default(react_native_1.View)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    height: 70%;\n    width: 50%;\n    flex-direction: column;\n    position: absolute;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    left: 18%;\n    max-height: 450px;\n"], ["\n    height: 70%;\n    width: 50%;\n    flex-direction: column;\n    position: absolute;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    left: 18%;\n    max-height: 450px;\n"])));
exports.TitleBox = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    width: 70%;\n    flex-basis: 18%;\n    text-align: center;\n    padding-top: ", "px;\n"], ["\n    width: 70%;\n    flex-basis: 18%;\n    text-align: center;\n    padding-top: ", "px;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isMedium(activeBreakpoint) ? 40 : 25;
});
exports.ModalTitle = styled_components_1.default(function (_a) {
  var width = _a.width,
      rest = __rest(_a, ["width"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    color: #262b33;\n    font-family: Roboto;\n    font-weight: bold;\n    font-size: ", "px;\n    line-height: 30px;\n"], ["\n    color: #262b33;\n    font-family: Roboto;\n    font-weight: bold;\n    font-size: ", "px;\n    line-height: 30px;\n"])), function (props) {
  return props.width * 0.08;
});
exports.ContentBox = styled_components_1.default(react_native_1.View)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    width: 92%;\n    flex-basis: 60%;\n"], ["\n    width: 92%;\n    flex-basis: 60%;\n"])));
exports.ModalText = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      width = _a.width,
      rest = __rest(_a, ["activeBreakpoint", "width"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    color: #262b33;\n    font-family: Roboto;\n    font-size: ", "px;\n    line-height: ", "px;\n    text-align: center;\n"], ["\n    color: #262b33;\n    font-family: Roboto;\n    font-size: ", "px;\n    line-height: ", "px;\n    text-align: center;\n"])), function (_a) {
  var width = _a.width;
  return width * 0.03;
}, function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isMedium(activeBreakpoint) ? 20 : 30;
});
exports.ButtonBox = styled_components_1.default(react_native_1.View)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    width: 80%;\n    flex-basis: 25%;\n"], ["\n    width: 80%;\n    flex-basis: 25%;\n"])));
exports.WrappButton = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    margin: 0 auto;\n    position: relative;\n    ", "\n"], ["\n    margin: 0 auto;\n    position: relative;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var medium = responsive_1.isMedium(activeBreakpoint);
  return "\n            top: " + (medium ? 5 : 54) + "px;\n            width: " + (medium ? 160 : 180) + "px;\n        ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;